import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { resetErrorMessage } from 'actions/internal';
import { loadAccount, loadAccountPlayerPreview, loadDashboardFilters } from 'actions/partner';
import { get } from 'lodash';
import { getTitle } from 'selectors';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import AccountHeaderContainer from './account/AccountHeaderContainer';
import AccountContainer from './account/AccountContainer';
import AccountPlayersPreviewContainer from './account/AccountPlayersPreviewContainer';

class AccountPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadDashboardFilters({source: 'init'});
    this.props.loadAccount(this.props.match.params, {source: 'init'});
    this.props.loadAccountPlayerPreview({accounts: this.props.match.params.id}, {source: 'init', from: 'account'});
  }

  render() {
    if (!this.props.isAuthChecked) return null;
    const { match, accountId, title } = this.props;
    const isLoading = accountId !== parseInt(match.params.id, 10);
    return (
      <DocumentTitle title={title}>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className='row'>
            { isLoading ?
              <div className='column u-margin-top--base'>
                <LoadingSpinner bgColor='light' />
              </div> :
              <div className="column">
                <AccountHeaderContainer />
                <div className="row u-margin-top--base">
                  <AccountContainer />
                  <AccountPlayersPreviewContainer />
                </div>
              </div> }
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthChecked: state.auth.isAuthChecked,
    accountId: get(state.account, 'id', 0),
    title: getTitle(state.account, 'name'),
  }
}

AccountPage.propTypes = {
  accountId: PropTypes.number,
  isAuthChecked: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  loadAccount: PropTypes.func.isRequired,
  loadAccountPlayerPreview: PropTypes.func.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, { loadAccount, loadAccountPlayerPreview, loadDashboardFilters, resetErrorMessage })(AccountPage);
